import DatePicker, {registerLocale} from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import * as Styled from './custom-date-picker.styles';
import ru from 'date-fns/locale/ru';
import {LanguageService, useService} from '@innowise-group/core';
import {StyledComponent} from 'styled-components';
import {preventDefaultOnChange} from '../../../modules/floors/utilities';
registerLocale('ru', ru);

export interface CustomDatePickerProps {
  selected?: Date | null | undefined;
  onChange: (value: Date | [Date, Date]) => void;
  excludeDateIntervals?: Array<{start: Date; end: Date}>;
  dateFormat?: string;
  minDate?: Date;
  maxDate?: Date;
  placeholderText?: string;
  isClearable?: boolean;
  disabled?: boolean;
  rangeType?: 'start' | 'end';
  popperPlacement?: any;
  open?: boolean;
  onInputClick?: () => void;
  onClickOutside?: () => void;
  startDate?: Date;
  endDate?: Date;
  selectsRange?: boolean;
  monthsShown?: number;
  zIndex?: number;
  disableKeyboardNavigation?: boolean;
  locale?: string;
  shouldCloseOnSelect?: boolean;
  peekNextMonth?: boolean;
  size?: 'default' | 'small' | 'extra-small' | 'large';
  isHighlighted?: boolean;
  Container?: StyledComponent<
    any,
    any,
    {
      disabled?: boolean;
      zIndex?: number;
      autoWidth?: boolean;
      size?: 'default' | 'small' | 'extra-small' | 'large';
      isHighlighted?: boolean;
    },
    never
  >;
  inline?: boolean;
}

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({
  onChange,
  rangeType = 'start',
  size = 'default',
  zIndex,
  Container = Styled.DatePickerContainer,
  isHighlighted = false,
  ...props
}) => {
  const {getAppLanguage} = useService(LanguageService);
  const onCalendarClose = props.selectsRange
    ? () => {
        const {startDate, endDate} = props;
        if (startDate && !endDate) onChange([startDate, startDate]);
      }
    : undefined;

  return (
    <Container
      disabled={props.disabled}
      zIndex={zIndex}
      autoWidth={props.monthsShown > 1}
      size={size}
      isHighlighted={isHighlighted}
    >
      <DatePicker
        {...props}
        onChange={onChange}
        locale={getAppLanguage()}
        onCalendarClose={onCalendarClose}
        onChangeRaw={preventDefaultOnChange}
      />
      <Styled.CalendarIcon type="u_calender" />
    </Container>
  );
};

export default CustomDatePicker;
